module.exports = __webpack_public_path__ + "static/lassebechmartinussen2-1440x679-14b091fb23afe5d9b6a7e883b0b5444a.jpg";